import { Utils } from "@/utilities/Utils";

export interface IBookingActionDetailVM {
    id: string;
    qrCodeGenerated: Date;
    created: Date;
    serverSaved: Date;
    rawScan: string;
    employee: string;
    hotel: string;
    scannedEmployee: string;
}

export class BookingActionDetailVM implements IBookingActionDetailVM {

    constructor(data?: IBookingActionDetailVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingActionDetailVM) {
        Utils.clone(data, this);
    }

    id: string = "";
    qrCodeGenerated: Date = new Date(Utils.emptyDateValue);
    created: Date = new Date(Utils.emptyDateValue);
    serverSaved: Date = new Date(Utils.emptyDateValue);
    rawScan: string = "";
    employee: string = "";
    hotel: string = "";
    scannedEmployee: string = "";
}